import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  invoiceId: yup.number().required(),
  amount: yup.number().required(),
});

export function useChargeWithWalletMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    return http.post(HTTP_ENDPOINTS.postChargeInvoiceWithWallet(), {
      invoice_id: req.invoiceId,
      requested_payment: req.amount,
    });
  }, options);
}
